import { times } from 'lodash';
import { DEFAULT_DURATION, DEFAULT_POSITION } from 'src/constants';
import { LayoutTypeIds, ProjectConfigInterface } from 'src/interfaces';

type TPositionConfigKey = keyof Pick<
  ProjectConfigInterface,
  | 'idmbPositionNumber'
  | 'odmbPositionNumber'
  | 'mcCafePositionNumber'
  | 'merchandiserPositionNumber'
>;

export const getPositionConfigKey = (
  layoutTypeId: LayoutTypeIds,
): TPositionConfigKey | undefined => {
  const positionConfigKeysMap: Record<LayoutTypeIds, TPositionConfigKey> = {
    [LayoutTypeIds.INDOOR]: 'idmbPositionNumber',
    [LayoutTypeIds.OUTDOOR]: 'odmbPositionNumber',
    [LayoutTypeIds.MCCAFE]: 'mcCafePositionNumber',
    [LayoutTypeIds.DIGITAL_MERCHANDISER]: 'merchandiserPositionNumber',
  };

  return positionConfigKeysMap[layoutTypeId];
};

export const getPositionsNumber = (
  positionConfigKeyData: Partial<ProjectConfigInterface> | undefined,
  positionConfigKey: TPositionConfigKey | undefined,
) => {
  let positionNumber: number;

  if (!positionConfigKey || !positionConfigKeyData) {
    return 0;
  }

  if (!positionConfigKeyData[positionConfigKey]) {
    positionNumber = DEFAULT_POSITION;
  } else {
    positionNumber = positionConfigKeyData[positionConfigKey] as number;
  }

  return positionNumber;
};

export const getPositionsByPositionNumber = (
  positionNumber: number,
  initialDurations?: Record<string, number>,
) =>
  times(positionNumber, (index) => ({
    position: index + 1,
    duration: initialDurations?.[index + 1] ?? DEFAULT_DURATION,
  }));
